module.exports = __webpack_public_path__ + "static/media/img-action-message@2x.69a28da2.png";